module.exports = __webpack_public_path__ + "img/sos-type-white.45cc165c.png";